module.exports = __webpack_public_path__ + "static/media/Tecnico.e6793878.svg";